import api from '@common/api/index.js'
import { formatDate } from '@/utils/index'
class contractHttpSet {
  constructor(ele) {
    // this.ele = ele;
  }
  //获取客户所有合同
  async getListElectricOperationsContractForClient(
    companyid,
    startTimes,
    endTimes,
    status
  ) {
    const endTime = formatDate(new Date(new Date().getTime()), 'yyyy-MM-dd')
    const startTime = formatDate(new Date(), 'yyyy') + '/01/01'
    let res = await api.contract.getListElectricOperationsContractForClient(
      companyid ? companyid : 0,
      startTimes ? startTimes : startTime,
      endTimes ? endTimes : endTime,
      '',
      status ? status : -1
    )
    if (res.success) {
      console.log(res)
      return res.data
    }
  }
  //获取所有合同
  async getListElectricOperationsContractForServiceProvider(
    companyid,
    clientsCompanyId,
    startTimes,
    endTimes,
    status
  ) {
    const endTime = formatDate(new Date(new Date().getTime()), 'yyyy-MM-dd')
    const startTime = formatDate(new Date(), 'yyyy') + '/01/01'
    let res = await api.contract.getListElectricOperationsContractForServiceProvider(
      companyid ? companyid : 0,
      clientsCompanyId,
      startTimes ? startTimes : startTime,
      endTimes ? endTimes : endTime,
      status ? status : -1
    )
    if (res.success) {
      console.log(res)
      return res.data
    }
  }
  //获取维保公司所有客户
  async getListClientsForElectricOperationsCompany() {
    let res = await api.contract.getListClientsForElectricOperationsCompany(
      0,
      null,
      null
    )
    if (res.success) {
      return res.data
    }
  }
  //获取全部公司
  async getListAllCompany() {
    let res = await api.contract.getListAllCompany()
    if (res.success) {
      return res.data
    }
  }
  //获取公司用户
  async getListAllUserByCompany(companyid) {
    let res = await api.contract.getListAllUserByCompany(companyid)
    if (res.success) {
      return res.data
    }
  }
  //获取视图
  async getcompanyFrontEndPageDefaultParam() {
    let res = await api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(
      0,
      '/powerOperations/workPlan/index',
      null
    )
    if (res.success && res.data.length > 0) {
      let result = await api.view.getViewTreeNodes(res.data[0].value)
      return result.data
    }
  }
  //提交
  async addElectricOperationsContract(
    name,
    signingTime,
    startTime,
    endTime,
    serviceProviderCompanyId,
    serviceProviderTransactorId,
    clientCompanyId,
    clientTransactorId,
    services
  ) {
    services.forEach((item) => {
      if (item.type != 5) {
        item.parmas = JSON.stringify(item.parmas)
      }
    })
    let res = await api.contract.addElectricOperationsContract(
      name,
      signingTime,
      startTime,
      endTime,
      serviceProviderCompanyId,
      serviceProviderTransactorId,
      clientCompanyId,
      clientTransactorId,
      services
    )
    if (res.success) {
      return res
    }
  }
}
export default contractHttpSet
